module.exports = __webpack_public_path__ + "static/media/pin.1e670346.svg";